export default {
  mounted(el) {
    setTimeout(() => {
      el.focus()
    }, 0)
  }
}
